export interface TreadSection {
  lengthIn: 24 | 36 | 48 | 60 | 96;
  qty: number;
}

const AVAILABLE_LENGTHS = [96, 60, 48, 36, 24] as const;

export function optimizeTreadSections(totalRunIn: number): TreadSection[] {
  const sections: TreadSection[] = [];
  let remaining = totalRunIn;
  for (const len of AVAILABLE_LENGTHS) {
    const qty = Math.floor(remaining / len);
    if (qty > 0) {
      sections.push({ lengthIn: len, qty });
      remaining -= qty * len;
    }
  }
  if (remaining > 0) {
    const existing = sections.find((s) => s.lengthIn === 24);
    if (existing) existing.qty += 1;
    else sections.push({ lengthIn: 24, qty: 1 });
  }
  return sections;
}
